import { configureStore } from "@reduxjs/toolkit";

import quoteReducer from "./slices/quotesSlice";

export const rtkStore = configureStore({
  reducer: {
    quotes: quoteReducer,
  },
});
